import type { RcFile } from '../../../upload';

export type LocalImageUpload = {
  filename: string;
  id: string;
  url: string;
};

export const prepareLocalImageUpload = (file: Blob | RcFile | string): LocalImageUpload => {
  if (typeof file === 'string') {
    throw new TypeError('Unexpected file');
  }

  const filename = file instanceof File ? file.name : 'image';
  const id = 'uid' in file ? file.uid : `${filename}-${file.size}-${Date.now()}`;

  return {
    filename,
    id,
    url: URL.createObjectURL(file),
  };
};
